import React, { FC } from "react";

import styles from "./Selector.module.scss";

type Props = {
  latestTermNo: number;
  selectedTermNo: number;
  onChange: (termNo: number) => void;
};

const Selector: FC<Props> = ({ latestTermNo, selectedTermNo, onChange }) => {
  return (
    <label className={styles.label}>
      <select
        className={styles.select}
        value={selectedTermNo}
        onChange={e => onChange(Number(e.target.value))}
      >
        {[...Array(latestTermNo)].map((_, index) => {
          const termNo = index + 1;
          return (
            <option key={termNo} value={termNo}>
              {termNo}回目
            </option>
          );
        })}
      </select>
    </label>
  );
};

export default Selector;
